// extracted by mini-css-extract-plugin
export default {"container":"inputContainer_container__dtS1h","label":"inputContainer_label__BqBft","content":"inputContainer_content__2-ZdP"};